

export default function Tolltip({message}) {
  return (
    <div className="text-xs font-bold text-themed3 bg-themel3 px-3 py-2 rounded-lg">
         {message}
    </div>
  )
}
